module.exports = __webpack_public_path__ + "img/Capita_Logo.5882307d.jpg";